import React from "react";
import {Button, Grid} from "@mui/material";

export class BottoneFinePagina extends React.Component {

    constructor(props) {
        super(props);
    }


    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        window.scrollTo(0, document.body.scrollHeight);
    }

    render() {
        return (
            <Grid container direction="row" spacing={1}>
                <Grid item>
                    <Button variant="contained" name='SubmitButton' onClick={this.handleChange}>VAI A FINE
                        PAGINA</Button>
                </Grid>
            </Grid>
        );
    }
}

